import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpenseCFStep = (state) => state.get('medicalExpenseCFStep');

const makeSelectMedicalExpenseCFStep = () => createSelector(
  selectMedicalExpenseCFStep,
  (stepMedicalExpenseCFState) => ({
    doYouHaveAnyOtherTypeOfCoverage: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'doYouHaveAnyOtherTypeOfCoverage']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    natureOfInjury: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'natureOfInjury']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'policyId']),
      ''
    ),
    nameOfTourOperatorOrCruiseOrLineOrAirline: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'nameOfTourOperatorOrCruiseOrLineOrAirline']),
      ''
    ),
    typeOfPolicy: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'typeOfPolicy']),
      ''
    ),
    contact: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'phoneNumber']),
      ''
    ),
    isTheClaimTheResultOfASicknessOrInjury: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'isTheClaimTheResultOfASicknessOrInjury']),
      ''
    ),
    natureOfSickness: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'natureOfSickness']),
      ''
    ),
    accidentOfInjury: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'accidentOfInjury']),
      ''
    ),
    dateNature: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'dateNature']),
      ''
    ),
    placeNature: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'placeNature']),
      ''
    ),
    wasThereAnyPreviousTreatmentForThisCondition: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'wasThereAnyPreviousTreatmentForThisCondition']),
      ''
    ),
    dateSicknessOrInjuryBegan: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),
    dateFirstTreated: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'dateFirstTreated']),
      ''
    ),
    nameOfPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'nameOfPhysician']),
      ''
    ),
    addressPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'addressPhysician']),
      ''
    ),
    cityOrTownPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'cityOrTownPhysician']),
      ''
    ),
    countryPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'countryPhysician']),
      ''
    ),
    zipPhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'zipPhysician']),
      ''
    ),
    phonePhysician: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'phonePhysician']),
      ''
    ),
    datesOfTreatment: mapWithDefault(
      stepMedicalExpenseCFState,
      () => stepMedicalExpenseCFState.getIn(['form', 'datesOfTreatment']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'expenseDescriptionOfItems']) && stepMedicalExpenseCFState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
    treatmentDates: mapWithDefault(stepMedicalExpenseCFState, () => stepMedicalExpenseCFState.getIn(['form', 'treatmentDates']) && stepMedicalExpenseCFState.getIn(['form', 'treatmentDates']).toJS(), []),
  })
);

const makeSelectMedicalExpenseCFStepErrors = () =>
  createSelector(selectMedicalExpenseCFStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpenseCFStep,
  makeSelectMedicalExpenseCFStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/selectors.js